module.exports = __webpack_public_path__ + "img/heading-search.f83c4e97.svg";